<script lang="ts">
	import { classes } from '$lib/utils';

	export let additionalClass: string = '';
</script>

<div class={classes(additionalClass, 'flex flex-row mb-8 text-md font-normal w-full items-center')}>
	<hr class="w-1/2 h-[1px] bg-gray-400/80 border-0" />
	<div class="px-4 text-gray-400/80">Or</div>
	<hr class="w-1/2 h-[1px] bg-gray-400/80 border-0" />
</div>
